import { Link } from '@tanstack/react-router'

export function NewFooter() {
  return (
    <footer className="nv-footer">
      <div className="nv-footer-inner">
        <div className="nv-footer-grid">
          <div>
            <div className="nv-footer-brand">PulseDigital</div>
            <p className="nv-footer-copy">
              Premium digital marketplace with fast delivery and clear support windows. Buy with confidence: secure checkout,
              verified policies, and support when it matters.
            </p>
          </div>

          <div>
            <div className="nv-footer-title">Store</div>
            <div className="nv-footer-links">
              <Link to="/shop">Pulse Shop</Link>
              <Link to="/cart">Cart</Link>
              <Link to="/faq">FAQ</Link>
            </div>
          </div>

          <div>
            <div className="nv-footer-title">Legal</div>
            <div className="nv-footer-links">
              <Link to="/terms">Terms</Link>
              <Link to="/refund">Refunds</Link>
              <Link to="/contact">Contact</Link>
            </div>
          </div>

          <div className="nv-footer-panel">
            <div className="nv-footer-title">Trust</div>
            <ul className="nv-footer-bullets">
              <li>SSL encrypted checkout</li>
              <li>MoneyMotion processing</li>
              <li>Vouch within 24h of delivery (eligible)</li>
              <li>Fast Discord-first support</li>
            </ul>
          </div>
        </div>

        <div className="nv-footer-bottom">
          <span>© {new Date().getFullYear()} PulseDigital</span>
          <span className="nv-footer-sep" aria-hidden />
          <span>Payments secured by MoneyMotion</span>
        </div>
      </div>
    </footer>
  )
}

